import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Link from 'components/shared/link';
import { BUTTON_SIZES, BUTTON_THEMES } from 'constants/button';

const Button = (props) => {
  const {
    className: additionalClassName,
    to,
    theme,
    size,
    loading,
    disabled,
    children,
    ...otherProps
  } = props;

  const Tag = to ? Link : 'button';

  const className = classNames(
    'button',
    `button_theme_${theme}`,
    `button_size_${size}`,
    { button_loading: loading },
    { button_disabled: disabled },
    additionalClassName
  );

  return (
    <Tag className={className} to={to} {...otherProps}>
      <span>{children}</span>
    </Tag>
  );
};

Button.defaultProps = {
  className: null,
  to: null,
  theme: BUTTON_THEMES.PRIMARY,
  size: BUTTON_SIZES.LG,
  loading: false,
  disabled: false,
};

Button.propTypes = {
  className: PropTypes.string,
  to: PropTypes.string,
  theme: PropTypes.oneOf(Object.values(BUTTON_THEMES)),
  size: PropTypes.oneOf(Object.values(BUTTON_SIZES)),
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

export default Button;
